<!-- SmartProgressions Login - Musical AI Experience -->
<div class="musical-login-container">
  <!-- AI-Generated Musical Background -->
  <div class="musical-background">
    <div class="ambient-gradients">
      <div class="gradient-layer layer-1"></div>
      <div class="gradient-layer layer-2"></div>
      <div class="gradient-layer layer-3"></div>
    </div>
    <div class="waveform-animation">
      <div class="wave-bar" *ngFor="let i of [].constructor(7); let idx = index"
           [style.animation-delay]="(idx * 0.1) + 's'"></div>
    </div>
  </div>

  <!-- Main Login Card -->
  <div class="login-card-musical">
    <!-- Premium App Logo Header -->
    <div class="musical-header">
      <div class="app-logo-container">
        <div class="logo-audio-ring">
          <div class="audio-pulse"></div>
        </div>
        <div class="app-logo-main">
          <!-- Official SmartProgressions Logo -->
          <img src="assets/logo/logo.svg"
               alt="SmartProgressions"
               class="official-logo"
               onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">

          <!-- Text Fallback Only (No Placeholder Graphics) -->
          <div style="display: none;" class="logo-text-fallback">
            <span class="brand-text">SmartProgressions</span>
          </div>
        </div>
      </div>

      <div class="musical-title-section">
        <h1 class="musical-title">SmartProgressions</h1>
        <h2 class="musical-subtitle">Flow through ethereal soundscapes</h2>
        <p class="musical-description">Sign in to continue your musical journey</p>
      </div>
    </div>

    <!-- OAuth Section -->
    <div class="musical-oauth-section">
      <div class="oauth-title">
        <span class="oauth-label">Connect with your music universe</span>
      </div>

      <div class="oauth-buttons-grid">
        <!-- Spotify -->
        <button type="button"
                class="musical-oauth-btn spotify"
                (click)="loginWithOAuth('spotify')"
                [disabled]="isLoading">
          <div class="oauth-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.062 14.42c-.19.307-.596.4-.904.21-2.474-1.51-5.588-1.854-9.254-1.015-.194.044-.39-.105-.434-.298-.043-.194.105-.39.298-.434 3.996-.917 7.372-.53 10.073 1.174.307.19.4.596.21.904zm1.292-2.87c-.24.386-.75.505-1.135.265-2.832-1.74-7.146-2.244-10.49-1.227-.383.116-.788-.099-.904-.482-.115-.383.1-.787.483-.903 3.83-1.166 8.644-.605 11.781 1.412.386.24.505.75.265 1.135zm.112-2.988c-3.395-2.016-8.996-2.204-12.243-1.218-.46.14-.947-.12-1.087-.58-.14-.46.12-.947.58-1.087 3.733-1.134 9.93-.915 13.826 1.402.422.251.56.8.31 1.222-.251.422-.8.56-1.222.31z"/>
            </svg>
          </div>
          <span class="oauth-text">Spotify</span>
        </button>

        <!-- Google -->
        <button type="button"
                class="musical-oauth-btn google"
                (click)="loginWithOAuth('google')"
                [disabled]="isLoading">
          <div class="oauth-icon">
            <svg viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
          </div>
          <span class="oauth-text">Google</span>
        </button>

        <!-- Discogs (Official Logo) -->
        <button type="button"
                class="musical-oauth-btn discogs"
                *ngIf="!discogsConnected"
                (click)="openDiscogsRedirect()"
                [disabled]="isLoading">
          <div class="oauth-icon discogs-official">
            <img src="assets/discogs-logo.png"
                 alt="Discogs"
                 class="discogs-logo-img">
          </div>
          <span class="oauth-text">Discogs</span>
        </button>
        <button type="button"
                class="musical-oauth-btn discogs"
                *ngIf="discogsConnected"
                (click)="disconnectDiscogs()">
          <div class="oauth-icon discogs-official">
            <img src="assets/discogs-logo.png"
                 alt="Discogs"
                 class="discogs-logo-img">
          </div>
          <span class="oauth-text">Desconectar</span>
        </button>

        <!-- Facebook -->
        <button type="button"
                class="musical-oauth-btn facebook"
                (click)="loginWithOAuth('facebook')"
                [disabled]="isLoading">
          <div class="oauth-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </div>
          <span class="oauth-text">Facebook</span>
        </button>
      </div>

      <!-- Banner de error fuera del grid -->
      <div *ngIf="discogsError" class="musical-error-banner centered">
        <span class="error-icon">⚠️</span>
        <span class="error-text">{{ discogsError }}</span>
      </div>
    </div>

    <!-- Divider -->
    <div class="musical-divider">
      <div class="divider-line"></div>
      <span class="divider-text">or continue with email</span>
      <div class="divider-line"></div>
    </div>

    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="musical-form">
      <div class="form-field">
        <label for="email" class="field-label">Email Address</label>
        <div class="input-container">
          <input type="email"
                 id="email"
                 formControlName="email"
                 class="musical-input"
                 [class.error]="email?.invalid && email?.touched"
                 placeholder="Enter your email"
                 autocomplete="email">
          <div class="input-glow"></div>
        </div>
        <div *ngIf="email?.invalid && email?.touched" class="error-message">
          <span *ngIf="email?.errors?.['required']">Email is required</span>
          <span *ngIf="email?.errors?.['email']">Please enter a valid email</span>
        </div>
      </div>

      <div class="form-field">
        <label for="password" class="field-label">Password</label>
        <div class="input-container">
          <input type="password"
                 id="password"
                 formControlName="password"
                 class="musical-input"
                 [class.error]="password?.invalid && password?.touched"
                 placeholder="Enter your password"
                 autocomplete="current-password">
          <div class="input-glow"></div>
        </div>
        <div *ngIf="password?.invalid && password?.touched" class="error-message">
          <span *ngIf="password?.errors?.['required']">Password is required</span>
          <span *ngIf="password?.errors?.['minlength']">Password must be at least 6 characters</span>
        </div>
      </div>

      <!-- Error Banner -->
      <div *ngIf="errorMessage" class="musical-error-banner">
        <div class="error-icon">⚠️</div>
        <span class="error-text">{{ errorMessage }}</span>
      </div>

      <!-- Submit Button -->
      <button type="submit"
              class="musical-submit-btn"
              [disabled]="loginForm.invalid || isLoading"
              [class.loading]="isLoading">
        <div class="btn-content">
          <span *ngIf="!isLoading" class="btn-text">Enter SmartProgressions</span>
          <div *ngIf="isLoading" class="loading-content">
            <div class="loading-spinner"></div>
            <span class="loading-text">Connecting...</span>
          </div>
        </div>
        <div class="btn-glow"></div>
      </button>
    </form>

    <!-- Footer -->
    <div class="musical-footer">
      <p class="footer-text">
        Don't have an account?
        <a href="#" class="signup-link">Join the Journey</a>
      </p>
    </div>
  </div>
</div>
